//

import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { MutationKeys, QueryKeys } from "../keys";
import { axiosInterceptor } from "..";
import {
  IResponse,
  IFinalizeGatewayRequest,
  ILoginResponse,
} from "../interface";
type IUseFinalizePaymentOptions = UseMutationOptions<
  ILoginResponse, //IResponse
  AxiosError<IResponse<string>>, //IErrorResponse
  IFinalizeGatewayRequest
>;

const useFinalizePayment = (options?: IUseFinalizePaymentOptions) => {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    ILoginResponse,
    AxiosError<IResponse<string>>,
    IFinalizeGatewayRequest
  >({
    mutationKey: [MutationKeys.FINALIZE_PAYMENT],
    mutationFn: async (data) => {
      return (await axiosInterceptor.post("b2b-payment/auth", data)).data;
    },
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.setQueryData(
        [QueryKeys.Organisation],
        data.b2bAdmin
      );
      window.localStorage.setItem("accessToken", data.token.accessToken);
      window.localStorage.setItem("refreshToken", data.token.refreshToken);
      options?.onSuccess?.(data, variables, context);
    },
  });

  return mutation;
};
export default useFinalizePayment;
